// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c78206{position:fixed;top:-1.5em;left:0;color:var(--secondary);font-size:.75em;font-weight:500;z-index:999}", ""]);
// Exports
exports.locals = {
	"tooltip": "c78206"
};
module.exports = exports;
